// form Definitions
import { descriptionField, systemNameField } from "./field-schema-form";

// types
import { IFieldGroupBuilt, IFieldTypes } from "../../typings";

export const FormSettingDefinition: IFieldGroupBuilt = {
  fields: [
    {
      fieldType: IFieldTypes.textField,
      name: "title",
      label: "Form Title",
      required: true,
      span: 2,
    },
    descriptionField,
    {
      fieldType: IFieldTypes.toggle,
      name: "allowContributorsToComment",
      label: "Allow Contributors to Add / View Comments",
      description:
        "Allow contributors assigned directly or through a role at any workflow step to add and view comments.",
      defaultValue: false,
      span: 4,
    },
    {
      ...systemNameField,
      readonly: true,
      description: "The System name is a unique identifier for the form",
    },
  ],
  min: 1,
  max: 1,
  label: "FieldGroups",
  name: "FieldGroups",
};
